// extracted by mini-css-extract-plugin
export default {"root":"CaseCreateDialogSubscriptionAlert_root__Ld+23"};